import axios, { AxiosError } from "axios";
import { IAxiosReturn, ISetting } from "../interface";
import { processAxiosError } from "../processAxiosError";

export interface HelpLink {
  id: number;
  linkUrl: string;
  linkLabel: string;
}

export type IHelpReturn = IAxiosReturn<HelpLink[]>;

/**
 * Load help links configured in settings.
 *
 * @param backEndUrl - Base backend URL
 * @returns IHelpReturn containing any configured help links
 */
export const loadHelpLinks = async (backEndUrl: string): Promise<IHelpReturn> => {
  // Get data
  try {
    const response: { data: ISetting } = await axios.get(`${backEndUrl}Settings/HelpLinks`);
    // Return successful result
    return {
      success: true,
      data: JSON.parse(response.data.value) as HelpLink[],
    };
  } catch (error: unknown) {
    // Handle if no setting exists yet
    if ((error as AxiosError).response?.status === 404) {
      return {
        success: true,
        data: [],
      };
    }
    return processAxiosError("Load help links failed", error);
  }
};
